// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueCookie from "vue-cookie";
import Public from "./assets/js/app.js";
import bridge from "./assets/js/nativeJsBridge.js";
import "./assets/js/directives.js";
import "font-awesome/css/font-awesome.min.css";
import "swiper/css/swiper.css";
import api from "./assets/js/common.js";
//在main.js引入qs
import QS from "qs";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
Vue.filter("relativeTime", value => {
  return dayjs().to(dayjs(value));
});

Vue.prototype.$api = api;
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";

/** 声明全局的header */
import Eheader from "@/components/template/eheader";

// //引入弹出层
// import {Popup} from 'vant';
// Vue.use(Popup);

Vue.use(Eheader);
Vue.component("Eheader", Eheader);

import Mint from "mint-ui";
import "mint-ui/lib/style.css";

Vue.use(Mint);
import {
  CellSwipe
} from "mint-ui";

Vue.component(CellSwipe.name, CellSwipe);

import MescrollVue from "mescroll.js/mescroll.vue";
Vue.use(MescrollVue);
Vue.component("mescroll-vue", MescrollVue);

import VueAMap from "vue-amap";

// Vue.use(VueAMap)
// Vue.config.productionTip = false
// VueAMap.initAMapApiLoader({
//   key: 'd11da7b0a5aef78a73248ae31c88ed26',
//   plugin: [
//     "AMap.Autocomplete", //输入提示插件
//     "AMap.PlaceSearch", //POI搜索插件
//     "AMap.Scale", //右下角缩略图插件 比例尺
//     "AMap.OverView", //地图鹰眼插件
//     "AMap.ToolBar", //地图工具条
//     "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
//     "AMap.PolyEditor", //编辑 折线多，边形
//     "AMap.CircleEditor", //圆形编辑器插件
//     "AMap.Geolocation" //定位控件，用来获取和展示用户主机所在的经纬度位置
//   ],
//   v: '1.4.4'
// });

//import VueWechatTitle from 'vue-wechat-title';
//Vue.use(VueWechatTitle)

Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(ElementUI);
Vue.use(preview);

Vue.prototype.$app = Public;
Vue.prototype.$axios = axios;
//配全局属性配置，在任意组件内可以使用this.$qs获取qs对象
Vue.prototype.$qs = QS;

//重写cookie方法，因为安卓app不能使用cookie
Vue.cookie.set = function(v, l) {
  localStorage.setItem(v, l);
};
Vue.cookie.get = function(v) {
  return localStorage.getItem(v);
};
Vue.cookie.remove = function(v) {
  localStorage.removeItem(v);
};

//vue.axios 允许跨域请求带cookie，session有效
Vue.prototype.$axios.defaults.withCredentials = true;
//vue.axios 请求拦截器
Vue.prototype.$axios.interceptors.request.use(
  function(config) {
    // 这里的config包含每次请求的内容
    console.log("--------------", config);
    config.credentials = true;
    // config.url.indexOf("/app/user/checkLogin"
    if (
      config.url.indexOf(
        "https://bdcgzh.sipac.gov.cn/gaoq_test2/MainPage/ZFBHandler.ashx"
      ) < 0 &&
      config.url.indexOf("http://bdcgzh.sipac.gov.cn/UploadFiles/files/news/") <
      0
    ) {
      if (Vue.cookie.get("token")) {
        console.log(Vue.cookie.get("token"));
        config.headers.Authorization = Vue.cookie.get("token");
        if (config.method === "get") {
          // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
          config.paramsSerializer = function(params) {
            return QS.stringify(params, {
              arrayFormat: "repeat"
            });
          };
        }
        return config;
      } else {
        config.headers.Authorization = "";
        return config;
      }
    } else {
      return config;
    }
  },
  function(err) {
    return Promise.reject(err);
  }
);

//设置超时时间
//Vue.prototype.$axios.defaults.timeout = 10000;

//vue.axios响应拦截器
Vue.prototype.$axios.interceptors.response.use(
  function(response) {
    console.log("$axios.response");
    // 判断登录方式
    var u = navigator.userAgent;
    var loginType = "";
    if (/MicroMessenger/.test(window.navigator.userAgent)) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          loginType = "weixinMini"; // 微信
        } else {
          loginType = "weixin"; // 微信
        }
      });
    } else if (/AlipayClient/.test(window.navigator.userAgent)) {
      loginType = "alipay"; // 支付宝
    } else {
      loginType = "others"; // 其他
    }
    console.log("1." + loginType);
    Vue.cookie.set("loginType", loginType);

    // 判断登录方式
    var u = navigator.userAgent;
    var loginType = "";
    if (/MicroMessenger/.test(window.navigator.userAgent)) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          loginType = "weixinMini"; // 微信
        } else {
          loginType = "weixin"; // 微信
        }
      });
    } else if (/AlipayClient/.test(window.navigator.userAgent)) {
      loginType = "alipay"; // 支付宝
      //loginType = 'others';  // 其他
    } else {
      loginType = "others"; // 其他
    }
    Vue.cookie.set("loginType", loginType);
    console.log("$axios.response");
    //判断登录方式
    var u = navigator.userAgent;
    var loginType = "";
    if (/MicroMessenger/.test(window.navigator.userAgent)) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          loginType = "weixinMini"; // 微信
        } else {
          loginType = "weixin"; // 微信
        }
      });
    } else if (/AlipayClient/.test(window.navigator.userAgent)) {
      loginType = "alipay"; // 支付宝
      //loginType = 'others';  // 其他
    } else {
      loginType = "others"; // 其他
    }
    Vue.cookie.set("loginType", loginType);
    var errorCode = response.data.errorCode;
    if (errorCode == 101 || errorCode == 102) {
      if (loginType == "weixinMini") {
        var token = Vue.cookie.get("token");
        if (token && token != "") {
          // 表示token失效
          Vue.cookie.remove("token");
          Vue.cookie.remove("userid");
          Vue.cookie.remove("centid");
          Vue.cookie.remove("name");
          Vue.cookie.remove("nickname");
          Vue.cookie.remove("phonenum");
          Vue.cookie.remove("avatar");
          Vue.cookie.remove("loginstate");
        }
        wx.miniProgram.postMessage({
          data: "token out"
        });
        // 返回小程序
        wx.miniProgram.reLaunch({
          url: "/pages/home/index"
        });
      } else if (loginType == "weixin") {
        next({
          path: "/main"
        });
      } else if (loginType == "alipay") {
        //window.open("https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021001108612047&scope=auth_user&redirect_uri=https://ebdc.ssipac.gov.cn:8443/suqianServer/alipayuser/index");
        /* window.open(
        "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021001108612047&scope=auth_user&redirect_uri=https://ebdc.ssipac.gov.cn:8443/suqianServer/alipayuser/indexToLogin"
      ); */
        window.open(
          "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021001108612047&scope=auth_user&redirect_uri=https://ebdc.ssipac.suqian.gov.cn:8001/suqianServer/alipayuser/indexToLogin"
        );
      } else {
        //其他情况
        next({
          path: "/"
        });
      }
      //Vue.prototype.$app.loginOut();
    } else if (errorCode == 103) {
      if (response.data.refreshToken) {
        Vue.cookie.set("token", response.data.refreshToken);
      }
    } else {}
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

//router拦截器，通过token有无判断
router.beforeEach((to, from, next) => {
  console.log("beforeEach");
  var path = to.path;
  //var loginType = Vue.cookie.get('loginType');
  var loginType = "";
  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    wx.miniProgram.getEnv(res => {
      if (res.miniprogram) {
        loginType = "weixinMini"; // 微信小程序
      } else {
        loginType = "weixin"; // 微信
      }
    });
  } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    loginType = "alipay"; // 支付宝
  } else {
    loginType = "others"; // 其他
  }
  console.log("2." + loginType);

  console.log("beforeEach");
  var path = to.path;
  //var loginType = Vue.cookie.get('loginType');
  var loginType = "";
  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    wx.miniProgram.getEnv(res => {
      if (res.miniprogram) {
        loginType = "weixinMini"; // 微信小程序
      } else {
        loginType = "weixin"; // 微信
      }
    });
  } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    loginType = "alipay"; // 支付宝
  } else {
    loginType = "others"; // 其他
  }

  if (document.getElementById("myvideo1")) {
    console.log(document.getElementById("myvideo1"));
    document.getElementById("myvideo1").style.display = "none";
  }
  console.log("beforeEach");
  var path = to.path;
  //var loginType = Vue.cookie.get('loginType');
  var loginType = "";
  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    wx.miniProgram.getEnv(res => {
      if (res.miniprogram) {
        loginType = "weixinMini"; // 微信小程序
      } else {
        loginType = "weixin"; // 微信
      }
    });
  } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    loginType = "alipay"; // 支付宝
  } else {
    loginType = "others"; // 其他
  }

  setTimeout(() => {
    Vue.cookie.set("loginType", loginType);
    if (loginType != "weixinMini" || loginType != "others") {
      var isSmrz = Vue.cookie.get("isSmrz");
      if (
        path === "/.well-known/pki-validation/fileauth.txt" ||
        path === "/Phone" ||
        path === "/phone" ||
        path === "/" ||
        path === "/main" ||
        path === "/mainLogin" ||
        path === "/wechatLogin" ||
        path === "/wechatFace" ||
        path === "/user/ad_detail" ||
        path === "/appIndex" ||
        path === "/applogin" ||
        path === "/template/error" ||
        path === "/indexLoginByToken" ||
        path === "/alipayLogin" ||
        path === "/weixinlogin" ||
        path === "/wechat" ||
        path == "/loginfromywtb" ||
        path == "/temperature/index" ||
        path == "/temperature/success" ||
        path == "/weixinMini" ||
        path == "/sqPage1" ||
        path == "/sqPage2" ||
        path == "/sqPage3"
      ) {
        if (to.meta.title) {
          if (path === "/main" || path === "/") {
            ap.setNavigationBar({
              // backgroundColor: '#88d1f4'
              backgroundColor: "#5840B0"
            });
          } else {
            ap.setNavigationBar({
              backgroundColor: "#fff"
            });
          }
          document.title = to.meta.title;
          const userAgent = window.navigator.userAgent.toLowerCase();
          if (/AlipayClient/i.test(userAgent) && ant) {
            ant.setTitle(to.meta.title);
          }
        } else {
          //document.title = (to.meta && to.meta.title) ? to.meta.title: '苏宿园区不动产';
          document.title = "苏宿园区不动产";
        }
        next();
      } else {
        if (path === "/main" || path === "/") {
          ap.setNavigationBar({
            // backgroundColor: '#88d1f4'
            backgroundColor: "#5840B0"
          });
        } else {
          ap.setNavigationBar({
            backgroundColor: "#fff"
          });
        }
        var token = Vue.cookie.get("token");
        if (!token || !/\S/.test(token)) {
          if (loginType == "weixin") {
            if (isSmrz) {
              next({
                path: "/wechatFace"
              });
            } else {
              next({
                path: "/wechatLogin"
              });
            }
          } else if (loginType == "alipay") {
            /* window.open(
              "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021001108612047&scope=auth_user&redirect_uri=https://ebdc.ssipac.gov.cn:8001/suqianServer/alipayuser/indexToLogin"
            ); */
            window.open(
              "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021001108612047&scope=auth_user&redirect_uri=https://ebdc.ssipac.suqian.gov.cn:8001/suqianServer/alipayuser/indexToLogin"
            );
          } else {
            //其他情况
            next({
              path: "/"
            });
          }
        } else {
          if (to.meta.title) {
            document.title = to.meta.title;
            const userAgent = window.navigator.userAgent.toLowerCase();
            if (/AlipayClient/i.test(userAgent) && ant) {
              ant.setTitle(to.meta.title);
            }
          } else {
            //document.title = (to.meta && to.meta.title) ? to.meta.title: '苏宿园区不动产';
            document.title = "苏宿园区不动产";
          }
          //next()
          if (loginType == "alipay") {
            if (path === "/printproof/index") {
              //特殊页面需要跳转页面进行刷脸
              let flag = Vue.cookie.get("AlipayFace");
              if (flag && (flag === true || flag === "true")) {
                next();
              } else {
                next({
                  path: "/authorFace",
                  query: {
                    url: path
                  }
                });
              }
            } else {
              next();
            }
          } else {
            next();
          }
        }
      }
    } else {
      if (path == "user/ad_detail") {
        if (to.meta.title) {
          document.title = to.meta.title;
          const userAgent = window.navigator.userAgent.toLowerCase();
          if (/AlipayClient/i.test(userAgent) && ant) {
            ant.setTitle(to.meta.title);
          }
        } else {
          document.title = "苏宿园区不动产";
        }
        next();
      } else if (path == "/weixinMini") {
        var token = Vue.cookie.get("token");
        if (!token || !/\S/.test(token)) {
          if (to.meta.title) {
            document.title = to.meta.title;
            const userAgent = window.navigator.userAgent.toLowerCase();
            if (/AlipayClient/i.test(userAgent) && ant) {
              ant.setTitle(to.meta.title);
            }
          } else {
            document.title = "苏宿园区不动产";
          }
          next();
        } else {
          let query = to.query;
          next({
            path: query.url
          });
        }
      } else {
        var token = Vue.cookie.get("token");
        if (!token || !/\S/.test(token)) {
          next({
            path: "/weixinMini",
            query: {
              url: path
            }
          });
        } else {
          if (to.meta.title) {
            document.title = to.meta.title;
            const userAgent = window.navigator.userAgent.toLowerCase();
            if (/AlipayClient/i.test(userAgent) && ant) {
              ant.setTitle(to.meta.title);
            }
          } else {
            document.title = "苏宿园区不动产";
          }
          next();
        }
      }
    }

    if (process.env.NODE_ENV === "development") {
      if (to.path === "/Phone") {
        next();
      }
    } else {
      if (to.path === "/Phone") {
        next({
          path: "/"
        });
      }
    }
    if (!from.name) {
      const routeExists = router.getRoutes().some(r => r.path === to.path || r.name === to.name);
      if (!routeExists) {
        next('/');
      } else {
        next();
      }
    } else {
      next();
    }
  }, 400);
});

router.afterEach((to, from, next) => {
  /*Vue.prototype.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    loadingInstance.close();
  });*/
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  bridge,
  components: {
    App,
    Eheader
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js